// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"807abd3d","317":"f27777f8","511":"dad4da11"}[chunkId] + ".chunk.js";
};